module.exports = __webpack_public_path__ + "static/media/tutorial-3.eb3e1109.jpg";